<template>
  <v-menu offset-y rounded="0" open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-btn text tile class="pa-0 nav-item" v-bind="attrs" v-on="on">
        <div class="d-flex align-center" :class="mainTxt">
          <v-icon class="locale-icon">mdi-earth</v-icon>
          <span class="ml-1 text-uppercase">{{ $i18n.locale }}</span>
        </div>
      </v-btn>
    </template>
    <v-list v-model="$i18n.locale" class="transparent pa-0 ma-0">
      <v-list-item
        v-for="(lang, i) in langs"
        :key="`Lang${i}`"
        :value="lang"
        @click="switchLocale(lang)"
        class="pa-0 ma-0 green"
        style="opacity: 0.75;"
      >
        <v-list-item-title
          class="mr-3 mt-3 my-0 pa-0 d-flex justify-end white--text"
        >
          <p class="locale-item ma-0 pa-0">
            {{ lang }}
          </p>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'LocaleSwitcher',
  props: {
    mainTxt: {
      type: Object,
      required: true,
    },
    menuTxt: {
      type: Object,
      required: true,
    },
    menuBkg: {
      type: Object,
      required: true,
    },
  },
  methods: {
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale
      }
      this.langs = this.filterLangs()
    },
    filterLangs() {
      return Object.keys(this.$i18n.messages)
        .map(key => {
          if (key != this.$i18n.locale) {
            return key
          }
        })
        .filter(obj => obj)
    },
  },
  data() {
    return {
      langs: this.filterLangs(),
    }
  },
}
</script>

<style lang="scss">
.locale-icon {
  font-size: 18px !important;
}

.locale-item {
  font-family: $body-font-family;
  font-weight: normal;
  font-size: 14px !important;
  text-transform: uppercase;
  height: 40px !important;
  letter-spacing: -0.05px;
}

.v-menu__content {
  font-size: 14px !important;
  // height: 40px !important;
  box-shadow: none !important;
  .v-list {
    // height: 40px !important;
    // overflow: hidden;
  }
}
</style>
